import { useState, useEffect } from 'react';
import usePage from './usePage';
import { transformProductsData } from '../utils/dataTransformer';

const useProductCategories = () => {
    const { page, loading } = usePage('home');
    const [categories, setCategories] = useState([]);

    useEffect(() => {
        if (page?.acf?.product_groups) {
            const sections = transformProductsData(page.acf.product_groups);
            const cats = sections
                .filter((section) => section.label !== 'SERVICE MODULE')
                .map((section) => ({
                    label: section.label,
                    subcategories: section.slides.map(slide => ({
                        title: slide.title,
                        slug: slide.slug
                    }))
                }));
            setCategories(cats);
        }
    }, [page]);

    return { categories, loading };
};


export default useProductCategories;
